import React, { useState } from "react";
import { MenuDatas } from "../components/Datas";
import { Link, useLocation } from "react-router-dom";
import { FiChevronDown, FiChevronRight } from "react-icons/fi";

function Sidebar() {
  const location = useLocation();

  // ✅ Fixes incorrect active detection
  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };

  // submenu toggle state
  const [closedMenus, setClosedMenus] = useState([
    MenuDatas.map((_, index) => index), // all menus start closed
  ]);

  const toggleSubmenu = (index) => {
    setClosedMenus((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );
  };

  return (
    <div className="bg-navy xl:shadow-lg py-6 px-4 xl:h-screen w-full border-r border-navy h-screen overflow-y-auto scrollbar-thin">
      <Link to="/">
        <img
          src="/saigonstar/logo.webp"
          alt="logo"
          className="w-2/4 h-12 ml-4 object-contain"
        />
      </Link>

      <div className="flex-colo gap-2 mt-12">
        {MenuDatas.map((item, index) => (
          <div key={index} className="w-full">
            {item.submenu ? (
              <div className="w-full">
                <button
                  onClick={() => toggleSubmenu(index)}
                  className={`flex justify-between gap-4 transitions group items-center w-full p-4 rounded-lg hover:bg-gray-500 ${
                    !closedMenus.includes(index) ? "" : ""
                  }`}
                >
                  <div className="flex items-center gap-4">
                    <item.icon className="text-xl text-subMain" />
                    <p className="text-sm font-medium text-gray-400 group-hover:text-subMain">
                      {item.title}
                    </p>
                  </div>
                  {closedMenus.includes(index) ? (
                    <FiChevronRight className="text-gray-400 text-base" />
                  ) : (
                    <FiChevronDown className="text-gray-400 text-base" />
                  )}
                </button>

                {!closedMenus.includes(index) && (
                  <div className="ml-10 flex flex-col gap-1 my-4">
                    {item.submenu.map((subItem, subIndex) => (
                      <Link
                        key={subIndex}
                        to={subItem.path}
                        className={`text-sm py-4 px-3 rounded-md p-4 hover:bg-gray-500 hover:text-subMain ${
                          isActive(subItem.path)
                            ? "text-subMain bg-gray-500"
                            : "text-gray-400"
                        }`}
                      >
                        {subItem.title}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <Link
                to={item.path}
                className={`flex gap-4 transitions group items-center w-full p-4 rounded-lg hover:bg-text ${
                  isActive(item.path) ? "bg-gray-500" : ""
                }`}
              >
                <item.icon className="text-xl text-subMain" />
                <p
                  className={`text-sm font-medium group-hover:text-subMain ${
                    isActive(item.path) ? "text-subMain" : "text-gray-400"
                  }`}
                >
                  {item.title}
                </p>
              </Link>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Sidebar;
